import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';

import { TellentAssistantBrandMarkComponent } from '../../brand-mark/tellent-assistant-brand-mark.component';

@Component({
  selector: 'tellent-assistant-tool-pill',
  imports: [TellentAssistantBrandMarkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tool-pill.component.html',
  styleUrl: './tool-pill.component.less',
})
export class TellentAssistantToolPillComponent {
  private readonly i18n = inject(I18nService);
  private readonly thinkingLabel = this.i18n.translate(
    'tlc.tellent_assistant.tool_call.thinking_status',
  );

  protected readonly label = computed(() => this.toolName() || this.thinkingLabel);

  public readonly toolName = input<string | null>(null);
}
